<template>
  <div data-module="row" :style="data.styles" :data-singleton="data.singleton" :id="data.id">
    <div v-for="(item, i) in columns" :key="`row-item--${i}`"
      :data-colstart="item.grid.start"
      :data-colend="item.grid.end"
      :data-index="i + 1"
      class="row-item"
    >
      <component
        :is="`component_${item.component}`"
        :key="item.component"
        :data="item"
        />
    </div>
  </div>
</template>

<script>

export default {

  name: 'module_row',

  props: ['data', 'window'],

  computed: {

    columns() {
      const window = this.window;
      const cols = this.data.columns;

      // add window data for use in blurb
      cols.forEach(function(col) {
        col.window = window; // eslint-disable-line
      });

      return cols;
    },
  },

};
</script>

<style lang="scss">
@import '~@/styles/_variables.scss';
@import '~@/styles/_mixins.scss';
@import '~@/styles/_typography.scss';

[data-module="row"] {
  @include grid($subgrid: true);
  @include spacer();

  @include mq($bp--tablet, up) {
    > * {
      grid-row: 1 / span 1;
    }
  }

  @include mq($bp--tablet, down) {
    > * {
      grid-column: 1 / span 12;
    }

    &:not([data-singleton="true"]) {
      margin-bottom: 0;

      > * {
        @include spacer();
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/row.vue